<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_step3_rates.svg`)"
            imageLabel="Rates & Fees"
            heading="What are your rates?"
            :step="7"
        >

            <div class="ph3 ph4-ns">
                <!-- rate inputs -->
                <div class="rates">
                    <DayRate v-model="dailyRate"/>
                    <CustomRate 
                        v-for="(customRate, index) in customRates" 
                        :key="index" 
                        :customRate="customRate"
                        @delete="$delete(customRates, index)"
                    />
                </div>
            
                <!-- add rate -->
                <div class="flex items-center pointer" @click="addRate">
                    <img src="@/assets/img/icon_listmytools_add.svg"/>
                    <h6 class="ml2 yellow">Add Rate</h6>
                </div>

                <!-- information -->
                <Info title="Tooliaba's Service Fee:">
                    <div class="mt1">
                    Tooliaba will be adding a service fee of 10% and application taxes about your rate.
                    </div>
                </Info>
            </div>
        </ListContainer>

        <!-- buttons -->
        <template slot="actionBar">
            <NavigationButtons :enabledForward="isEnabled" back="Back" forward="Next" @backClick="$router.push('/owner-delivery')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import DayRate from '@/components/list/rates/DayRate.vue';
import CustomRate from '@/components/list/rates/CustomRate.vue';
import Info from '@/components/list/shared/Info.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import { mapMutations } from 'vuex';

export default {
    data: function() {
        return {
            dailyRate: 0,
            customRates: []
        };
    },
    components: {
        ShadowBoxContainer,
        ListContainer,
        DayRate,
        CustomRate,
        Info,
        NavigationButtons
    },
    methods: {
        ...mapMutations('newListing', ['setRates']),
        addRate() {
            this.customRates.push({
                rate: 0,
                timeFrame: 4
            });
        },
        next() {
            this.setRates({
                dailyRate: this.dailyRate,
                rates: this.customRates
            });
            this.$router.push('/deposit');
        }
    },
    computed: {
        isEnabled() {
            var hasZero =
                this.dailyRate === 0 ||
                this.customRates.some(x => x.rate === 0);

            return !hasZero;
        }
    }
};
</script>
